export const config = {
  moduleName: "vytlky",
  moduleNameCamelCase: "Výtlky",
  type: "vytlky",

  mainFileName: "Vytlky.svelte",

  texts: {
    title: "Výtlky",
    dialog: {
      title: "Máte aktívnu editáciu výtlk.",
      text: "Zrušením editácie ostane výtlk nezmenený.\n Chcete editáciu zrušiť?",
      confirm: "Áno, zrušiť editáciu",
      cancel: "Nie, pokračovať v editovaní",
    },
    editPovodneKreslenia:
      "Jedno alebo viac kreslení, ktoré boli súčasťou editovaného výtlku, nie je teraz zvolené. Chcete uložiť výtlk s aktuálne zvolenými kresleniami?",
    pridat: "Pridať výtlk",
    zobrazit: "Zobraziť výtlk",
    dialogZmazat: {
      title: "Určite chcete zmazať tento výtlk?",
      text: "Ak má výtlk viac geometrií, budú zmazané aj tie. Táto akcia sa nedá vrátiť.",
      confirm: "Áno",
      cancel: "Zrušiť",
    },
    formTitle: "Nový výtlk",
  },
};
